import { nodeTypes, START } from "./nodeTypes";
import { cloneDeep } from "lodash";
import { mrTypes } from "./mrTypes";
import { IF } from "./nodeTypes";
const initialStartPosition = { x: 88, y: 323 };
export const flowChartStructure = {
  offset: { x: 0, y: 0 },
  nodes: {},
  links: {},
  selected: {},
  hovered: {},
};
const createEmptyWorkFlow = () => {
  const id = uuidv4();
  const nodeProps = nodeTypes.find((o) => o.type === START);
  const nodeStart = {
    id: id,
    position: initialStartPosition,
    type: nodeProps.type,
    properties: nodeProps.properties,
    ports: nodeProps.ports,
  };
  const tmpStructure = cloneDeep(flowChartStructure);
  tmpStructure.nodes = { [id]: nodeStart };
  return tmpStructure;
};
export const jdcWorkFlow = (workflow) => {
  if (!workflow.nodes) return createEmptyWorkFlow();
  const { nodes, connections } = workflow;
  const flow = { offset: { x: 0, y: 0 } };
  flow["nodes"] = jdcNodeToChartNode(nodes);
  flow["links"] = connectionToLink(connections, flow.nodes);
  flow["selected"] = {};
  flow["hovered"] = {};
  flow["quantifier"] = workflow.quantifier;
  return flow;
};
export const jdcMrFlow = (jdcModels) => {
  const { models, connections } = jdcModels;
  if (!models) return flowChartStructure;
  const flow = { offset: { x: 0, y: 0 } };
  flow["nodes"] = jdcModelToCharNode(models);
  flow["links"] = modelConnectionToLink(connections, flow.nodes);
  flow["selected"] = {};
  flow["hovered"] = {};
  return flow;
};
/*
transforms the jdc nodes into nodes that are able to understand the flow-chart library.

structure:{
  id,
  type,
  ports,
  properties
}
 */
const jdcNodeToChartNode = (nodes) => {
  const GrNode = {};
  for (const node of nodes) {
    //iterating about available nodes
    const key = node.id;
    GrNode[key] = {
      id: key,
      position: node.position, //adds a new property , which comes from the jdc
      ...addProperty(
        nodeTypes.find((o) => o.type === node.type), // adds the characteristics declared in the list of nodesTypes
        { name: node.name, args: node.args }
      ),
    };
  }
  return GrNode;
};

const jdcModelToCharNode = (models) => {
  const GrNode = {};
  for (const model of models) {
    const key = model.id;
    GrNode[key] = {
      id: key,
      position: model.position,
      ...addProperty(
        mrTypes.find((o) => o.type === model.type),
        { name: model.name, source: model.source, attributes: model.attributes }
      ),
    };
  }
  return GrNode;
};
/*
interprets the connections that are declared in the jdc(workflow)
to connections that are layers of understanding the library(flow-chart)
structure:{
  id,
  from:{
    nodeId,
    portId
  }
  to:{
    nodeId,
    portId
  }
}
 */
const connectionToLink = (connections, nodes) => {
  const link = {};
  for (const key of Object.keys(connections)) {
    //iteration of declared connections
    const node = nodes[key]; //the start node is saved ("from")
    const { targets } = connections[key]; //list of nodes to be targeted ("to")
    targets.forEach((o) => {
      if (node.type === IF) {
        //conditional in case the node is of type "if", as it will be treated differently
        o.yes.forEach((x) =>
          findIdsAndCreateLink("yes", link, node, nodes[x.node], null)
        );
        o.no.forEach((x) =>
          findIdsAndCreateLink("no", link, node, nodes[x.node], null)
        );
      } else {
        findIdsAndCreateLink(null, link, node, nodes[o.node], null);
      }
    });
  }
  return link;
};
const existsLink = (links, nodeId, target) => {
  // for (const key in links) {
  //   const link = links[key];
  //   if (link.properties && link.properties.secondAssociation) {
  //     if (link.properties.secondAssociation[nodeId]) {
  //       return true;
  //     }
  //   }
  // }
  // return false;
  return Object.keys(links).some((key) => {
    const link = links[key];
    return (
      link &&
      link.from &&
      target &&
      link.from.nodeId === nodeId &&
      link.to.nodeId === target.id
      // ||(link.from.nodeId === target.id && link.to.nodeId === nodeId)
    );
  });
};
const modelConnectionToLink = (connections, nodes) => {
  const link = {};
  for (const key of Object.keys(connections)) {
    const connection = connections[key];
    const { targets } = connection;
    const parentNode = nodes[key];
    targets.forEach((o) => {
      const { associationType, id, ...otherProps } = o;
      if (
        !existsLink(link, key, o) &&
        connections[id] &&
        associationType !== "has-many"
      ) {
        const secondAssociation = {
          [id]: {
            model: connections[id].model,
            target: connections[id].targets.find(
              (target) =>
                target.id === key && target.origin === otherProps.target
            ),
          },
        };
        findIdsAndCreateLink(null, link, parentNode, nodes[id], {
          connectionsProps: {
            ...otherProps,
            associationType: associationType,
          },
          secondAssociation: secondAssociation,
        });
      }
    });
  }
  return link;
};
//finds the ids of the ports that are interacting ("from ->to") and creates the link
const findIdsAndCreateLink = (
  type,
  link,
  { id: fromId, ports: fromPorts }, // type , list of link,from node , to node
  { id: toId, ports: toPorts },
  properties
) => {
  let fromPortId = "";
  let toPortId = "";
  const linkId = uuidv4();

  for (const key of Object.keys(fromPorts)) {
    if (
      typeof type === "string" && //applies when the origin node is an "if"
      fromPorts[key].properties.value &&
      fromPorts[key].properties.value === type
    ) {
      fromPortId = key;
    }
    if (
      fromPorts[key].properties.mode &&
      fromPorts[key].properties.mode === "output" &&
      typeof type !== "string"
    ) {
      fromPortId = key;
    }
  }
  for (const key of Object.keys(toPorts)) {
    if (
      toPorts[key].properties.mode &&
      toPorts[key].properties.mode === "input"
    )
      toPortId = key;
  }
  link[linkId] = linkPort({
    fromPortId: fromPortId,
    toPortId: toPortId,
    linkId: linkId,
    fromNodeId: fromId,
    toNodeId: toId,
    properties: properties,
  });
};
const addProperty = (Type, property) => {
  const tmp = cloneDeep(Type);
  for (const key of Object.keys(property)) {
    tmp.properties[key] = property[key];
  }
  return { type: tmp.type, properties: tmp.properties, ports: tmp.ports }; //se ignoran las propiedades extras
};
//creates a uuid that meets the version 4 standard
export const uuidv4 = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

const linkPort = ({
  fromPortId,
  toPortId,
  linkId,
  fromNodeId,
  toNodeId,
  properties,
}) => {
  const link = {
    id: linkId,
    from: {
      nodeId: fromNodeId,
      portId: fromPortId,
    },
    to: {
      nodeId: toNodeId,
      portId: toPortId,
    },
  };
  if (properties) link["properties"] = properties;
  return link;
};
